import {Selector} from '@ngxs/store';
import {CampaignsState} from '@store/campaigns/campaigns.state';
import {CampaignsStateModel} from '@store/campaigns/campaigns-state.model';
import {IResponse} from '@interfaces/response';
import {ICampaign, ICampaignActive, ICampaignHistory} from '@interfaces/campaigns';

export class CampaignsSelectors {
  @Selector([CampaignsState])
  static getCampaignsByType(state: CampaignsStateModel): IResponse<ICampaign | ICampaignActive | ICampaignHistory> | null {
    return state.campaigns;
  }

  @Selector([CampaignsState])
  static getCampaignsCurrentPage(state: CampaignsStateModel): number {
    return state.currentPage;
  }

  @Selector([CampaignsState])
  static getCampaignsSearchValue(state: CampaignsStateModel): string {
    return state.searchParam;
  }

  @Selector([CampaignsState])
  static getCampaignsLoader(state: CampaignsStateModel): boolean {
    return state.loader;
  }

  @Selector([CampaignsState])
  static getCampaignsPerPage(state: CampaignsStateModel): number {
    return state.itemsPerPage;
  }
}
